import React, { useState } from 'react';
import { Form, Image } from 'react-bootstrap';
import '../../../Assets/css/myaccount.css'
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '@mui/material/Button';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { Address_details, base_url, media_details,contact_number, postHeader, Email_details } from '../../../Helpers/request';
import swal from 'sweetalert';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { BsTelephone } from 'react-icons/bs';
import { IoMailOutline } from 'react-icons/io5';
import { HiOutlineLocationMarker } from 'react-icons/hi';

const Contact = () => {
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    const [first_name, setFirst_name] = useState('');
    const [last_name, setLast_name] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comment, setComment] = useState('');

    const formsubmit = (e) => {
        e.preventDefault();
        var data = {
            first_name,
            last_name,
            email,
            phone,
            comment
        }
        axios.post(base_url + '/user/contact', data, {
            headers: postHeader
        })
            .then(response => {
                if (response.data.status == 1) {
                    setFirst_name("");
                    setLast_name("");
                    setEmail("");
                    setComment("");
                    setPhone("");
                    return swal(response.data.message, "", "success");
                } else {
                    return swal(response.data.message, "", "error");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>
            <div className="rcs_myaccount_section">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb mb-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Contact Us</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                </Container>
                <div className="rcs_appointment mt-5">
                    <Container>
                        <Row className="w-100 m-auto">
                            <Col className="p-md-0 mb-5">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13254.231291458622!2d-84.3655358!3d33.8495122!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f50f5c9e194c8b%3A0xdc5d561fee9fab9b!2sEBEN-EZER%20JEWELRY%20REPAIR%20ATELIER%20LLC!5e0!3m2!1sen!2sin!4v1693561569050!5m2!1sen!2sin" width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy"></iframe>
                            </Col>
                        </Row>
                        <Row className="w-100 m-auto">
                            <Col sm={12} md={6} className="p-md-0">
                                <Form onSubmit={formsubmit}>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="First Name"
                                                type="text"
                                                variant="outlined"
                                                value={first_name}
                                                onChange={(e) => setFirst_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Last Name"
                                                type="text"
                                                variant="outlined"
                                                value={last_name}
                                                onChange={(e) => setLast_name(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Email Address"
                                                type="Email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <TextField
                                                id="outlined-basic"
                                                label="Phone"
                                                type="number"
                                                variant="outlined"
                                                InputProps={{ inputProps: { min: 0 } }}
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <TextField
                                                id="filled-multiline-static"
                                                label="Your Message"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Button variant="contained" type="submit" className="rcs_acc_button"> <MailOutlineIcon className="mr-2" /> Send Message </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col sm={12} md={6}>
                                <div className="rcs_contact_content">
                                    <h1>Contact Us</h1>
                                    <p>Please send us a message, and our staff will be happy to help you with any questions you have.</p>
                                    <ul className="rcs_content_address">
                                        <li>
                                            <h5>STORE ADDRESS</h5>
                                            <address class="mb-0">
                                                <li>
                                                <div className='d-flex' onClick={(e) => { window.open(Address_details.link, "_blank")}}>
                    <p className='  fontMessiri'><HiOutlineLocationMarker className='mr-2'/> </p>
                    <li className='  fontMessiri mb-0'>{Address_details.textLine1}
                      <br /> {Address_details.textLine2}</li>
                    </div>
                                                </li>
                                                <li>  <div className='d-flex' onClick={(e) => { window.location.href = contact_number.link }}>
                    <p className='  fontMessiri mb-0'><BsTelephone className='mr-2'/> </p>
                    <li className='  fontMessiri mb-0' >{contact_number.text}</li>
                    </div></li>
                    <li><div className='d-flex' onClick={(e) => { window.location.href = Email_details.link }}>
                   <p className='  fontMessiri'> <IoMailOutline className='mr-2'/> </p>
                    <li className="pb-1 fontMessiri" >{Email_details.text}</li>
                   </div></li>
                                            </address>
                                        </li>
                                        <li>
                                            <h5>STORE HOURS</h5>
                                            <strong>Monday - Thursday :</strong> 10:00 am - 6:00 pm<br /><strong>Friday :</strong> 10:00 am - 5:00 pm<br /><strong>Saturday & Sunday:</strong> Closed<br />
                                        </li>
                                    </ul>
                                    <h4>FOLLOW US</h4>
                                    <ul className="rcs_content_social">
                                        {
                                            media_details.map((media, id) =>
                                                <li key={id}><NavLink onClick={() => window.open(`${media.account_link}`, "_blank")} to="#"><Image src={media.account_img} alt={media.account_alt}></Image></NavLink></li>
                                            )
                                        }
                                        {/* <li><NavLink onClick={() => window.open("https://twitter.com/BelgiumWebnet", "_blank")} to="#"><Image src={Social7} alt="twitter"></Image></NavLink></li>
                                        <li><NavLink onClick={() => window.open("https://www.instagram.com/belgium_webnet/", "_blank")} to="#"><Image src={Social2} alt="Instagram"></Image></NavLink></li>
                                        <li><NavLink onClick={() => window.open("https://www.linkedin.com/company/belgium-webnet/", "_blank")} to="#"><Image src={Social3} alt="Linkdin"></Image></NavLink></li>                                         */}
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default Contact;